import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { consoleForecastLots } from "./queries";

/*
 * The lots a concierge can forecast against.
 *
 * Deliberately not the Settings allLots query: that one is gated on
 * parking_lots:read, which is an admin permission the desk does not hold.
 * Lots are rarely edited, so this does not poll.
 */
export default function useForecastLots(installationId) {
  const { data, loading, error } = useQuery(consoleForecastLots, {
    skip: !installationId,
    fetchPolicy: "cache-and-network",
  });

  const rawLots = data?.consoleForecastLots;

  // On-site lots first: that is where the desk's own cars go, so it is the lot
  // they will want preselected and the one they check most often.
  const lots = useMemo(
    () =>
      (rawLots ?? [])
        .filter(Boolean)
        .slice()
        .sort((a, b) => {
          if (a.type !== b.type) return a.type === "ONSITE" ? -1 : 1;
          return (a.name ?? "").localeCompare(b.name ?? "");
        }),
    [rawLots],
  );

  return {
    lots,
    defaultLotId: lots[0]?.id ?? null,
    loading: loading && !rawLots,
    error,
  };
}
